module.exports = __webpack_public_path__ + "static/media/carimage.c4c32f3d.svg";